import { AppConfig } from '../../../service/config';
import { NavigatorConfig } from './interface';
import { CommunicationConfig } from './iacCommunication';

export interface ThirdPartyConfig {
  navigator?: NavigatorConfig;
  communication?: CommunicationConfig;
  upp?: {
    iac_allowed_use_cases?: IacAllowedUseCases;
  }
}

export interface IacAllowedUseCases {
  [key: string]: string[];
}

let thirdPartyConfig: ThirdPartyConfig;
let appConfig: AppConfig;

export class Config {

  public static init(config: AppConfig): void {
    appConfig = config;
    thirdPartyConfig = config.thirdParty || {};
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public static extend(data: any): void {
    // istanbul ignore next else
    if (typeof (data) === 'object') {
      thirdPartyConfig = merge({}, thirdPartyConfig, data);
      appConfig.thirdParty = thirdPartyConfig;
    }
  }

  public static get(): ThirdPartyConfig {
    return thirdPartyConfig;
  }

  public static getCoreConfig(): AppConfig['core'] {
    return appConfig.core;
  }

}

// The code below is the old merge implementation with some util functions
// from angular.js to keep the old behavior for the migration.
//
// URL: https://github.com/angular/angular.js/blob/465d1734559ca4a7f4aa24387060f88fcc53ecb1/src/Angular.js#L364
// License: MIT
//
// TODO we should check if a) a deep clone is really needed and b) if we really
// need extra checks for Date, RegExp and DOM elements.

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function merge(dst: any, ...objs: any[]): any {
  for (let i = 0, ii = objs.length; i < ii; ++i) {
    const obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) {
      continue;
    }
    const keys = Object.keys(obj);
    for (let j = 0, jj = keys.length; j < jj; j++) {
      const key = keys[j];
      const src = obj[key];

      if (isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (!isObject(dst[key])) {
            dst[key] = Array.isArray(src) ? [] : {};
          }
          merge(dst[key], src);
        }
      } else {
        dst[key] = src;
      }
    }
  }

  return dst;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isObject(value: any): boolean {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isFunction(value: any): boolean {
  return typeof value === 'function';
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isDate(value: any): boolean {
  // using window.toString throws 'Invalid calling object' in IE
  return Object.prototype.toString.call(value) === '[object Date]';
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isRegExp(value: any): boolean {
  // using window.toString throws 'Invalid calling object' in IE
  return Object.prototype.toString.call(value) === '[object RegExp]';
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isElement(node: any): boolean {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}
